import { render, staticRenderFns } from "./NEWPREDICT.vue?vue&type=template&id=4143a3fa&scoped=true&"
import script from "./NEWPREDICT.vue?vue&type=script&lang=js&"
export * from "./NEWPREDICT.vue?vue&type=script&lang=js&"
import style0 from "./NEWPREDICT.vue?vue&type=style&index=0&id=4143a3fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4143a3fa",
  null
  
)

export default component.exports